<fas-service-dynamic-table
  [columns]="columns"
  [dataMode]="'client'"
  [fullDataService]="fetchOskSubscriptionPlans"
  [columnTemplates]="{
    planNameTemplate:planNameTemplateRef
  }"
>

<ng-template #planNameTemplateRef let-row>
  <div class="plan-tag py-1 px-2 text-sm border-round-sm" 
  [style.backgroundColor]="row.bgColor"
  [style.color]="row.fgColor">
  {{ row.planName }}
  </div>
</ng-template>
</fas-service-dynamic-table>
